export const StudiesTypes = {
  Default: '2',
};
